import appConf from "../app-conf";
const setup = appConf[process.env.REACT_APP_CLIENT];
const environment = process.env.NODE_ENV;
const project = "Order Checkout Fail";
const server = null;
const service = null;
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  application: false,
  routes: {
    label: "Order Checkout Fail",
    prefix: "/corporate/order/fail",
  },
  setup,
};

export default config;
